window.Products.Clothing.FittedPoloShirt = function() {}
window.Products.Clothing.FittedPoloShirt.inherits(window.Products.Clothing.Shirt);